// "Show guidance as I work" — the persistent user setting above every once-only flag. Compact; manual help ("How TWS works") is never affected.
import { useOnboarding } from "./context";

export function GuidanceSwitch({ compact = false }) {
  const o = useOnboarding();
  if (!o) return null;
  const on = !!o.memory.guidanceEnabled;
  if (compact) {
    return (
      <button type="button" data-testid="guidance-switch" role="switch" aria-checked={on} onClick={() => o.setGuidance(!on)}
        title="Show guidance as I work — TWS can briefly explain tools the first time they become useful."
        className="font-mono-panel text-[10px] uppercase tracking-[0.18em] text-stone-400 hover:text-[#8C3A2A] transition-colors">GUIDANCE {on ? "ON" : "OFF"}</button>
    );
  }
  return (
    <label data-testid="guidance-switch-row" className="mt-3 flex items-start gap-2 text-[12px] text-stone-600">
      <input type="checkbox" data-testid="guidance-switch" role="switch" aria-checked={on} checked={on} onChange={(e) => o.setGuidance(e.target.checked)} className="mt-0.5 accent-[#8C3A2A]" />
      <span><span className="text-stone-800">Show guidance as I work</span> <span className="text-stone-500">— TWS can briefly explain tools the first time they become useful.</span></span>
    </label>
  );
}
